import getApiBaseUrl from '@/utils/getBaseUrl';
import { useQuery } from '@tanstack/react-query';
import useGetProfile, { Profile } from './useGetProfile';

export default function useGetLoanOfficers() {
  const { data: user } = useGetProfile();
  const token = window.localStorage.getItem('_token');

  return useQuery<Profile[]>({
    queryKey: ['ADMIN_LOAN_OFFICERS'],
    queryFn: async () => {
      const response = await fetch(
        `${getApiBaseUrl()}/api/v1/users/loan-officers`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data.data;
    },
    enabled: user?.role === 'ADMIN',
  });
}
